import React, { FC } from 'react';
import { GiTwoCoins } from 'react-icons/gi';
import { Button } from '@chakra-ui/react';
import { useCollectAllFees } from '@app/hooks/positions/useCollectAllFees';
import { PositionFromTokenId } from '@app/hooks/v3/usePositions';

interface Props {
  positions: PositionFromTokenId[] | undefined;
}

export const CollectAllFeesButton: FC<Props> = ({ positions }) => {
  const { isAvailable, collectAll, isLoading } = useCollectAllFees(positions);

  return (
    <Button
      width={['100%', '180px']}
      variant="rowCompact"
      onClick={collectAll}
      isDisabled={!isAvailable}
      sx={{
        gap: 2,
        display: 'flex',
        padding: '0 16px',
        '> svg': {
          width: '24px',
          height: '24px',
          color: 'orange'
        }
      }}
    >
      {isLoading ? (
        'Loading...'
      ) : (
        <>
          <GiTwoCoins width="24px" height="24px" /> Collect all fees
        </>
      )}
    </Button>
  );
};
